module.exports = __webpack_public_path__ + "static/media/printer.caca59cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/printer.png
// module id = 1640
// module chunks = 0